import React from "react";
import "style/MarksimArt.scss";

// The two text illustrations of the market-simulation page, rebuilt from
// the former SVG files (SvgHeaderMiddle / SvgMachineLearning, whose text was
// outlined to paths) so their words can be translated.

/** Blue disc with two lines ("Bridging / the Gap"). */
export const GapBadge = ({ lines }: { lines: string[] }) => (
  <div className="art-gap" aria-hidden="true">
    {lines.map((line) => (
      <span key={line}>{line}</span>
    ))}
  </div>
);

/** Two overlapping outlined circles: top text, overlap word, bottom text. */
export const MlCircles = ({ lines }: { lines: string[] }) => (
  <div className="art-ml" aria-hidden="true">
    <svg viewBox="0 0 207 362" fill="none">
      <circle
        cx="103.5"
        cy="103.5"
        r="102.5"
        stroke="currentColor"
        strokeWidth="2"
      />
      <circle
        cx="103.5"
        cy="258.5"
        r="102.5"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
    <span className="art-ml__top">{lines[0]}</span>
    <span className="art-ml__mid">{lines[1]}</span>
    <span className="art-ml__bottom">{lines[2]}</span>
  </div>
);
